import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import api from '../../api/axios';

const AsignarMesasModal = ({ show, onClose, reserva, onSuccess }) => {
  const [mesasDisponibles, setMesasDisponibles] = useState([]);
  const [mesasSeleccionadas, setMesasSeleccionadas] = useState([]);
  const [loading, setLoading] = useState(false);

  const buscarMesas = async () => {
    try {
      setLoading(true);
      const res = await api.get('/mesas/libres-por-horario', {
        params: {
          fecha: reserva.fecha,
          hora: reserva.hora,
          comensales: reserva.personas,
        },
      });
      setMesasDisponibles(res.data);
    } catch (err) {
      console.error('Error al buscar mesas:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      await api.put(`/reservas/${reserva.id}/asignar-mesas`, {
        mesas: mesasSeleccionadas,
      });
      onSuccess();
    } catch (err) {
      console.error('Error al asignar mesas:', err);
    }
  };

  useEffect(() => {
    if (show) {
      buscarMesas();
      setMesasSeleccionadas([]);
    }
  }, [show]);

  const toggleMesa = (mesaId) => {
    setMesasSeleccionadas((prev) =>
      prev.includes(mesaId)
        ? prev.filter((id) => id !== mesaId)
        : [...prev, mesaId]
    );
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Asignar mesas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Cliente:</strong> {reserva.nombre_cliente}
          <br />
          <strong>Comensales:</strong> {reserva.personas}
          <br />
          <strong>Fecha:</strong> {reserva.fecha}
          <br />
          <strong>Hora:</strong> {reserva.hora}
        </p>

        {loading ? (
          <Spinner animation="border" />
        ) : mesasDisponibles.length === 0 ? (
          <p>No hay mesas disponibles</p>
        ) : (
          <Form>
            {mesasDisponibles.map((mesa) => (
              <Form.Check
                key={mesa.id}
                type="checkbox"
                label={`Mesa ${mesa.name} (${mesa.comensales || '-'} comensales)`}
                checked={mesasSeleccionadas.includes(mesa.id)}
                onChange={() => toggleMesa(mesa.id)}
              />
            ))}
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={mesasSeleccionadas.length === 0}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AsignarMesasModal;